import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LETTERS = "CELLAT".split("");

export const Preloader = ({ onDone }) => {
  const [count, setCount] = useState(0);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      i += 1;
      setCount(i);
      if (i >= 36) {
        clearInterval(interval);
        setTimeout(() => setExiting(true), 400);
        setTimeout(onDone, 1300);
      }
    }, 45);
    return () => clearInterval(interval);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!exiting && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[95] bg-[#0A0A0A] flex flex-col items-center justify-center"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex">
            {LETTERS.map((l, i) => (
              <motion.span
                key={i}
                className="font-blackletter text-[#EDEDEA] text-6xl md:text-8xl"
                initial={{ opacity: 0, filter: "blur(12px)", y: 20 }}
                animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
                transition={{ delay: 0.15 + i * 0.12, duration: 0.6 }}
              >
                {l}
              </motion.span>
            ))}
          </div>
          <div className="mt-8 flex items-baseline gap-2">
            <span data-testid="preloader-counter" className="text-[#C1121F] font-mono text-2xl tabular-nums">
              {String(count).padStart(2, "0")}
            </span>
            <span className="text-[#525252] text-xs tracking-[0.3em]">/ 36</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
